module.exports = __webpack_public_path__ + "static/media/review_offer_home.6ab9a4f9.png";